import { Routes } from '@angular/router';

import { SERVICE_ANALYTICS } from '../shared/models/list';

import { OfferProductCardComponent } from './components/cards/product-card/offer-product-card-component ';
import { productExitGuard } from './guards/product-exit.guard';
import { configurationFieldNamesTranslationGuard } from './guards/configuration-field-names-translation.guard';
import { ProductEditionCardComponent } from './components/cards/product-card/product-edition-card.component';
import { productEnterGuard } from './guards/product-enter.guard';
import { ProductCardComponent } from './components/cards/product-card/product-card.component';

export const routes: Routes = [

	{
		path: 'card/:productId',
		component: OfferProductCardComponent,
		canActivate: [configurationFieldNamesTranslationGuard],
		canDeactivate: [productExitGuard],
		data: { pageName: 'Products - Card', service: SERVICE_ANALYTICS.PRODUCT },
	},
	{
		path: 'productCard/:id',
		component: ProductCardComponent,
		canActivate: [configurationFieldNamesTranslationGuard],
		data: { pageName: 'Products - Card', service: SERVICE_ANALYTICS.PRODUCT },
	},
	{
		path: 'template/:productId/:productType',
		component: ProductEditionCardComponent,
		canActivate: [productEnterGuard, configurationFieldNamesTranslationGuard],
		canDeactivate: [productExitGuard],
		data: { pageName: 'Products - Template Card', service: SERVICE_ANALYTICS.PRODUCT },
	},
	{
		path: 'template/:productId/:productType/:configurationNumber',
		component: ProductEditionCardComponent,
		canActivate: [productEnterGuard, configurationFieldNamesTranslationGuard],
		canDeactivate: [productExitGuard],
		data: { pageName: 'Products - Template Card', service: SERVICE_ANALYTICS.PRODUCT },
	}
];
